import React, { useState, useEffect } from 'react';
import {
    Row,
    Col,
    Card,
    CardHeader,
    CardBody,
    Spinner,
    FormGroup,
    Input,
    Form,
    Button
} from 'reactstrap';
import { useForm } from 'react-hook-form';
import Select from 'react-select';

//Components
import RichTextEditor from '../../../components/RichTextEditor';

//Api
import documento_api from '../../../api/documento_api';

//Helpers
import { showMessage } from '../../../helpers/message';
import downloadBase64File from '../../../helpers/downloadFile';

export default function DocumentoFicha({ id, btnVoltar }) {
    const { register, errors, handleSubmit, setValue, clearErrors, getValues, reset, watch } = useForm({ mode: "onBlur" });

    //Estado de controle do loading na tela
    const [show_loading, set_show_loading] = useState(false);

    //Estado de controle do valor do tipo
    const [tipo, set_tipo] = useState("Avulso");

    //Estado de controle do valor do status
    const [status, set_status] = useState("Ativo");

    //Estado de controle do valor do base64 do arquivo
    const [arquivo, set_arquivo] = useState("");

    //Estado de controle do base64 do documento
    const [base64, set_base64] = useState(null);

    //Estado de controle do valor do html
    const [html, set_html] = useState("");

    //Função que carrega os dados iniciais do formulario
    const loadForm = (documento) => {
        if (documento) {
            setValue("identificacao", documento.identificacao);
            setValue("tipo", documento.tipo);
            setValue("status", documento.status);
            set_status(documento.status);
            set_tipo(documento.tipo);
            setValue("orientacoes", documento.orientacoes);
            if (documento.tipo == "Personalizado") {
                setValue("html", documento.html);
                set_html(documento.html);
            } else if (documento.tipo == "Arquivo") {
                set_arquivo(documento.arquivo);
                set_base64(documento.base64);
            }
        } else {
            register({ name: "html" });
            setValue("tipo", "Avulso", true);
            setValue("status", "Ativo", true);
        }
    }

    //Opções do campo de tipo
    const options_tipo = [
        { label: "Avulso", value: "Avulso" },
        { label: "Personalizado", value: "Personalizado" },
        { label: "Arquivo", value: "Arquivo" },
    ]

    //Opções do campo de status
    const options_status = [
        { label: "Ativo", value: "Ativo" },
        { label: "Inativo", value: "Inativo" },
    ]

    //Função de onChange do tipo
    const handleChange = (name, value) => {
        clearErrors(name);
        setValue(name, value, true);
        if (name == "tipo") {
            set_tipo(value);
        } else if (name == "status") {
            set_status(value);
        } else if (name == "html") {
            set_html(value);
        }
    }

    //Função de submit dos dados do documento
    const onSubmit = (data) => {
        const json_submit = {
            ...data,
            arquivo: arquivo
        }
        set_show_loading(true);
        if (id) {
            documento_api.put({ ...json_submit, Documento_Id: id }).then(response => {
                if (response.status !== 200) {
                    showMessage("Aviso", response.message, 'error', null);
                    return;
                }
                showMessage("Sucesso", "Documento salvo com sucesso!", "success", btnVoltar);
            }).finally(f => set_show_loading(false));
        } else {
            documento_api.post({ ...json_submit }).then(response => {
                if (response.status !== 200) {
                    showMessage("Aviso", response.message, 'error', null);
                    return;
                }
                showMessage("Sucesso", "Documento salvo com sucesso!", "success", btnVoltar);
            }).finally(f => set_show_loading(false));
        }
    }

    //Função de onChange do arquivo de anexo
    const onChangeAnexo = (e) => {
        const FR = new FileReader();

        FR.addEventListener("load", function (evt) {
            const base64 = evt.target.result;
            set_arquivo(base64);
        });
        if (e.target.files)
            FR.readAsDataURL(e.target.files[0]);
    }

    //Função que carrega os dados do documento
    const loadDocumento = () => {
        if (id) {
            set_show_loading(true);
            documento_api.getItem(id).then(response => {
                if (response.status !== 200) {
                    showMessage("Aviso", response.message, 'error', null);
                    return;
                }
                loadForm(response.data);
            }).finally(f => set_show_loading(false));
        } else {
            loadForm();
        }
    }
    useEffect(() => {
        loadDocumento();
    }, []);

    useEffect(() => {
        const tipo = watch('tipo');
        if (tipo === 'Personalizado') {
            register({ name: 'html', required: true });
        } else {
            register({ name: 'html' });
        }
    }, [watch]);
    return (
        <div className='content'>
            {show_loading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <Spinner></Spinner>
                    </div>
                </div>
            }
            <div>
                <Button onClick={btnVoltar}>
                    <i className="fas fa-chevron-left"></i> Voltar
                </Button>
            </div>
            <Card>
                <CardHeader className="d-flex align-items-center justify-content-between">
                    <h4 className="titleCard mb-0">+ Adicionar documento</h4>
                </CardHeader>
                <CardBody>
                    <Form onSubmit={handleSubmit(onSubmit)}>
                        <Row>
                            <Col lg="6" md="12">
                                <FormGroup>
                                    <label className="form-control-label">Identificação</label>
                                    <Input className="form-control"
                                        autocomplete="off"
                                        type="text"
                                        name="identificacao"
                                        innerRef={register({ required: true })}
                                    />
                                    {errors.identificacao && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                </FormGroup>
                            </Col>
                            <Col lg="3" md="12">
                                <FormGroup>
                                    <label className="form-control-label">Tipo</label>
                                    <Select
                                        name="tipo"
                                        options={options_tipo}
                                        getOptionLabel={o => o.label}
                                        getOptionValue={o => o.value}
                                        value={options_tipo.filter(f => f.value == tipo)}
                                        onChange={(o) => handleChange("tipo", o.value)}
                                        classNamePrefix="select"
                                        placeholder="[ Selecione ]"
                                        ref={e => register(
                                            { name: "tipo" },
                                            { required: true })
                                        }
                                    />
                                    {errors.tipo && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                </FormGroup>
                            </Col>
                            <Col lg="3" md="12">
                                <FormGroup>
                                    <label className="form-control-label">Status</label>
                                    <Select
                                        name="status"
                                        options={options_status}
                                        getOptionLabel={o => o.label}
                                        getOptionValue={o => o.value}
                                        value={options_status.filter(f => f.value == status)}
                                        onChange={(o) => handleChange("status", o.value)}
                                        classNamePrefix="select"
                                        placeholder="[ Selecione ]"
                                        ref={e => register(
                                            { name: "status" },
                                            { required: true })
                                        }
                                    />
                                    {errors.status && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                </FormGroup>
                            </Col>
                            <Col lg="12" md="12">
                                <FormGroup>
                                    <label className="form-control-label">Orientações</label>
                                    <Input className="form-control"
                                        autocomplete="off"
                                        type="textarea"
                                        name="orientacoes"
                                        innerRef={register({ required: false })}
                                    />
                                    {errors.orientacoes && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                </FormGroup>
                            </Col>
                            {
                                getValues("tipo") == "Personalizado" && !show_loading &&
                                <Col lg="12" md="12">
                                    <RichTextEditor name={"html"} value={html} onChange={(e) => handleChange("html", e.target.value)} />
                                    {errors.html && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                </Col>
                            }
                            {
                                getValues("tipo") == "Arquivo" &&
                                <Col lg="12" md="12">
                                    <div className='d-flex align-item-center justify-content-between'>
                                        <Input className="form-control w-75"
                                            autocomplete="off"
                                            type="file"
                                            name="arquivo"
                                            onChange={onChangeAnexo}
                                            innerRef={register({ required: !arquivo })}
                                        />
                                        {
                                            base64 &&
                                            <Button color="danger" className="mb-0 mt-0 w-25" onClick={() => { downloadBase64File(base64, getValues("identificacao").trim() + '.pdf') }}>
                                                Download Arquivo
                                            </Button>
                                        }
                                    </div>
                                    {errors.arquivo && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                </Col>
                            }
                            <Col lg="12" md="12" sm="12" className="text-center">
                                <Button color="success" type="submit">
                                    <i className="fas fa-save"></i>  Salvar
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </CardBody>
            </Card>
        </div>
    )
}